import axios from 'axios'
import BaseModel from "@/models/BaseModel.js";

export default class Planning extends BaseModel {
  fields =  {
    'sumber_dana': {
      label: 'Sumber Dana',
      type: 'enum',
      rules: 'required',
      options: []
    },
    'kode_kegiatan_id': {
      label: 'Kegiatan',
      type: 'enum',
      rules: 'required',
      options: []
    },
    'account_code_id': {
      label: 'Kode Rekening',
      type: 'enum',
      rules: 'required',
      options: []
    },
    // 'nama_kegiatan' : {
    //   label: 'Nama Kegiatan',
    //   type: 'text',
    //   rules: 'required'
    // },
    'uraian_kegiatan' : {
      label: 'Uraian Kegiatan',
      type: 'textarea',
      rules: ''
    },
    // 'bulan_kegiatan' : {
    //   label: 'Bulan',
    //   type: 'enum',
    //   rules: 'required',
    //   multiple: true,
    //   options: {
    //     '01-01': 'Januari',
    //     '02-01': 'Februari',
    //     '03-01': 'Maret',
    //     '04-01': 'April',
    //     '05-01': 'Mei',
    //     '06-01': 'Juni',
    //     '07-01': 'Juli',
    //     '08-01': 'Agustus',
    //     '09-01': 'September',
    //     '10-01': 'Oktober',
    //     '11-01': 'November',
    //     '12-01': 'Desember',
    //   }
    // },
    // 'bulan_kegiatan' : {
    //   label: 'Bulan Kegiatan',
    //   type: 'date',
    //   rules: 'required'
    // },
    // 'harga_satuan' : {
    //   label: 'Harga Satuan',
    //   type: 'price',
    //   rules: 'required'
    // },
    // 'jenis_satuan' : {
    //   label: 'Jenis Satuan',
    //   type: 'text',
    //   rules: 'required'
    // },
    // 'total_harga' : {
    //   label: 'Total Harga',
    //   type: 'price',
    //   rules: 'required'
    // },
    // 'volume' : {
    //   label: 'Volume',
    //   type: 'number',
    //   rules: 'required'
    // },
    // 'frekuensi' : {
    //   label: 'Frekuensi',
    //   type: 'number',
    //   rules: ''
    // },
  }

  endpoint = process.env.VUE_APP_API_URL + 'school-purchases';

  create (value) {
    return new Promise((resolve, reject) => {
      axios.post(this.endpoint, {
        ... this.initForEndpoint(value),
        details: value.details
      }).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }

  updateRealisasi (id, details) {
    return new Promise((resolve, reject) => {
      axios.patch(this.endpoint + '/' + id + '/realisasi', {
        details: details
      }).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }

  update (id, value) {
    return new Promise((resolve, reject) => {
      axios.patch(this.endpoint + '/' + id, {
        ... this.initForEndpoint(value),
        details: value.details
      }).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
